// extracted by mini-css-extract-plugin
module.exports = {"loaderBackdrop":"Loader_loaderBackdrop__h2ILN","fullScreen":"Loader_fullScreen__2NymM","loaderContainer":"Loader_loaderContainer__3AAQQ"};